export const getters = {
    isWeb: state => state.context === 'web',
    isMobile: state => state.context === 'mobile',
    endpoint: state => state.requiresAuthentication ? state?.appConfig?.api?.endpoint
        : state?.appConfig?.webApi?.endpoint,
    publicEndPoint: state => state?.appConfig.webApi.endpoint,
    getStatusMessages: state => state.statusMessages,
    getLoadingState: state => state.loading,
    getCheckForFeatureToggle: state => toggleId => state.featureToggles.includes(toggleId),
    isApiAuthorized: (state) => (apiType) => {
        return !!state.userData?.apis.find(item => item.apiType === apiType);
    },
    getSharedUserMapGuid: state => state.sharedUserMapGuid,
    getUserMapMessage: state => state.userMapMessage
};
